import { appConfig } from 'configs';

const EXTERNAL_DATA_URL_1 = `${appConfig.node_api_base_url}/cities`;
const EXTERNAL_DATA_URL_2 = `${appConfig.node_api_base_url}/specialties?Type=SPECIALTY&Language=fa`;
const EXTERNAL_DATA_URL_3 = `${appConfig.node_api_base_url}/specialties?Type=EDUCATION_LEVEL&Language=fa`;

function generateEducationLevelCitySpecialtyList(educationLevels, cities, specialties) {
  let list = [];
  educationLevels.forEach(e => {
    cities.forEach(c => {
      specialties.forEach(s => {
        list.push({educationLevel: e.Slug, city: c.Slug, specialty: s.Slug})
      })
    })
  })
  return list;
};

function generateSiteMap(educationLevelAndCityAndSpecialty) {
  return `
   <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
      ${educationLevelAndCityAndSpecialty
        .map((s) => {
          return `
            <url>
              <loc>${`${appConfig.site_url}/explore/doctors/${s.educationLevel}/${s.specialty}/city/${s.city}`}</loc>
            </url>
        `;
        })
      .join('')}
   </urlset>
 `;
}

function SiteMap() {
  // getServerSideProps will do the heavy lifting
}
export const getServerSideProps = async ({ res }) => {
  // We make an API call to gather the URLs for our site
  const request1 = await fetch(EXTERNAL_DATA_URL_1);
  const request2 = await fetch(EXTERNAL_DATA_URL_2);
  const request3 = await fetch(EXTERNAL_DATA_URL_3);

  const cities = await request1.json();
  const specialties = await request2.json();
  const educationLevels = await request3.json();

  const educationLevelAndCityAndSpecialty = generateEducationLevelCitySpecialtyList(educationLevels, cities.slice(201, 251), specialties);

  // We generate the XML sitemap with the posts data
  const sitemap = generateSiteMap(educationLevelAndCityAndSpecialty);

  res.setHeader('Content-Type', 'text/xml');
  // we send the XML to the browser
  res.write(sitemap);
  res.end();

  return {
    props: {},
  };
};

export default SiteMap;